var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ContentHeader'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-container"},[_c('div',{staticClass:"text-center"},[_c('h3',{staticClass:"font-weight-700"},[_vm._v("404")]),_c('br'),_c('h5',[_vm._v("PAGE NOT FOUND")])])])
}]

export { render, staticRenderFns }